// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bib_tr","LeftMenu__link":"ir_b bib_vt bib_a bib_rc","LeftMenu__link__icon":"ir_c"};